import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const etapes = [
  "Visite technique à domicile pour mesurer le volet et vérifier l'espace du coffre",
  "Dépose de l'organe de manœuvre manuel : sangle, cordon ou manivelle",
  "Choix et installation du moteur Somfy adapté au poids et aux dimensions",
  "Raccordement électrique sur prise proche ou pose d'un filin dissimulé",
  "Réglage des fins de course et programmation des commandes io ou RTS",
  "Tests de fonctionnement et démonstration à l'utilisateur",
];

export default function CommentSeDeroule() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Technician%20in%20a%20blue%20uniform%20installing%20a%20Somfy%20tubular%20motor%20inside%20a%20previously%20manual%20roller%20shutter%20box%20during%20an%20electrification%20project%20in%20a%20French%20home%20near%20Strasbourg%20clean%20work%20environment%20natural%20daylight%20professional%20service%20photography%20warm%20tones&width=700&height=520&seq=elec-somfy-comm&orientation=landscape" alt="Technicien installant un moteur Somfy lors d'une électrification à Strasbourg" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>

          <div>
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-5">
              Comment se déroule l'électrification Somfy
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-5">
              L'électrification commence par une visite technique à domicile. Nos techniciens analysent votre volet existant : type de tablier, matériau des lames, poids estimé, largeur de la baie et espace disponible dans le coffre. Nous vérifions aussi la présence d'une prise de courant à proximité. Ce diagnostic nous permet de choisir le moteur Somfy parfaitement adapté et de vous présenter un devis détaillé, sans engagement.
            </p>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              L'intervention dure généralement une à deux heures par volet. Nous commençons par déposer la sangle, le cordon ou la manivelle existante. Le moteur tubulaire Somfy est ensuite inséré dans l'axe du tablier, directement relié à la manœuvre. Le raccordement électrique est réalisé de manière propre et sécurisée. Nous réglons les butées haute et basse, programmons les commandes de votre choix et testons plusieurs cycles de montée et descente. Vous repartez avec un volet entièrement électrique, prêt à être piloté par télécommande.
            </p>
            <ul className="space-y-3">
              {etapes.map((etape) => (
                <li key={etape} className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-cyan text-sm"></i>
                  </span>
                  <span className="text-brand-text text-base">{etape}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}